var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_783_2342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.3335 14H10.6668",
    stroke: "#222529",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3335V14.0002",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 2.6665H11.3332",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3332 2.6665V7.99984C11.3332 8.88389 10.982 9.73174 10.3569 10.3569C9.73174 10.982 8.88389 11.3332 7.99984 11.3332C7.11578 11.3332 6.26794 10.982 5.64281 10.3569C5.01769 9.73174 4.6665 8.88389 4.6665 7.99984V2.6665",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 7.33317C4.06971 7.33317 4.66667 6.73622 4.66667 5.99984C4.66667 5.26346 4.06971 4.6665 3.33333 4.6665C2.59695 4.6665 2 5.26346 2 5.99984C2 6.73622 2.59695 7.33317 3.33333 7.33317Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 7.33317C13.4032 7.33317 14.0002 6.73622 14.0002 5.99984C14.0002 5.26346 13.4032 4.6665 12.6668 4.6665C11.9304 4.6665 11.3335 5.26346 11.3335 5.99984C11.3335 6.73622 11.9304 7.33317 12.6668 7.33317Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_783_2342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.eb04d4f33cb86ee98e72db63ca47ad35.svg";
export { ForwardRef as ReactComponent };